import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'removeUnderscore',
})
export class RemoveUnderscorePipe implements PipeTransform {
    transform(value: any, args?: any): any {
        if(typeof value !== 'string' || value?.toString()?.includes('@')) return value;
        return  value.replace(/_/g, ' ');
    }
}
